import React, { Component } from "react";
import { connect } from "react-redux";

import { SET_TICKET_LIST_RELOAD } from "../../actions/types";

import HelpAndSupportHeader from "../CommonComponents/HelpAndSupportHeader";
import TumbnailImg from "./TumbnailImg";
import DisplayImage from "./DisplayImage";
import ErrorMessage from "../CommonComponents/ErrorMessage";

import attactment from "../../svg/additional.svg";

import api from "../../api/api";

class NewComment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitBtnDisable: true,
      description: "",
      imgFiles: [],
      displayImage: false,
      imageNo: 0,
      fileToDisplay: null,
      displayErrorPopup: false,
      linkId: this.props.match.params.id,
      userId: ""
    };
  }

  /**
   * this is for history or goback
   */
  goBack = () => {
    if (!this.state.displayImage) {
      this.props.history.goBack();
    } else {
      this.setState({
        displayImage: false
      });
    }
  };

  /**
   * for the visibility of the submit btn
   */
  onEnableSubmitBtn = () => {
    if (document.getElementById("ticketDesc").value.trim().length > 0) {
      this.setState({
        submitBtnDisable: false
      });
    } else {
      this.setState({
        submitBtnDisable: true
      });
    }
  };

  fileUploadClick = () => {
    document.getElementById("fileUpload").click();
  };

  getFileList = event => {
    if (event.target.files.length > 0) {
      this.setState({
        imgFiles: [...this.state.imgFiles, event.target.files[0]]
      });
    }
    document.getElementById("fileUpload").files = null;
  };

  onSubmitBtnClick = () => {
    this.setState({
      submitBtnDisable: true
    });
    api.displayMainLoader();
    let uploadFilesId = [];
    if (this.state.imgFiles.length === 0) {
      let dataToSend = {
        status: 2,
        comment: document.getElementById("ticketDesc").value,
        imageArray: uploadFilesId,
        authorId: this.props.authorId,
        user_id: this.state.userId
      };
      api
        .addNote(this.state.linkId, dataToSend)
        .then(data => {
          this.setState({
            submitBtnDisable: false
          });
          this.props.ticketUpdated();
          api.displayHideLoader();
          this.goBack();
        })
        .catch(error => {
          console.log(error);
          api.displayHideLoader();
          this.setState({
            displayErrorPopup: true
          });
        });
    } else {
      let dataToSend = {
        status: 2,
        comment: document.getElementById("ticketDesc").value,
        imageArray: this.state.imgFiles,
        authorId: this.props.authorId,
        user_id: this.state.userId
      };
      api
        .addNoteWithAttachments(this.state.linkId, dataToSend)
        .then(data => {
          this.setState({
            submitBtnDisable: false
          });
          this.props.ticketUpdated();
          api.displayHideLoader();
          this.goBack();
        })
        .catch(error => {
          console.log(error);
          api.displayHideLoader();
          this.setState({
            displayErrorPopup: true
          });
        });
    }
  };

  onTumbnailClick = no => {
    --no;
    this.setState({
      displayImage: true,
      imageNo: no,
      fileToDisplay: this.state.imgFiles[no]
    });
  };

  deleteOption = no => {
    this.setState({
      displayImage: false,
      imgFiles: this.state.imgFiles.splice(no, -1)
    });
  };

  errorCloseCLick = () => {
    this.setState({
      displayErrorPopup: false
    });
  };

  componentDidMount() {
    api.displayHideLoader();
    const location = this.props.location;
    this.setState({
      userId: location.search && location.search.split('=')[1]
    });

  }

  render() {
    api.displayHideLoader();
    let i = 0;
    return (
      <div>
        {this.state.displayImage ? (
          <DisplayImage
            deleteOption={this.deleteOption.bind(this)}
            no={this.state.imageNo}
            image={this.state.fileToDisplay}
            displayDeleteBtn={true}
            back={this.goBack.bind(this)}
          />
        ) : (
          ""
        )}
        {this.state.displayErrorPopup ? <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)} /> : ""}
        <HelpAndSupportHeader displayMessage={this.props.headerMessage} back={this.goBack.bind(this)} />
        <div className="body-container">
          <div className="ticket-box-container" style={{ marginTop: "15px" }}>
            <div className="ticket-box">
              <div className="ticket-box-title">MESSAGE</div>
              <textarea
                id="ticketDesc"
                className="ticket-description-textarea"
                placeholder="Write here"
                maxLength="512"
                style={{ paddingLeft: 0 }}
                onChange={this.onEnableSubmitBtn.bind(this)}
                style={{ height: "150px" }}
              />
            </div>
          </div>
          {this.state.imgFiles.map(image => {
            return (
              <TumbnailImg
                image={image}
                key={++i}
                no={i}
                onTumbnailClick={this.onTumbnailClick.bind(this)}
                imageLink={false}
              />
            );
          })}
          <div className="ticket-attactment-icon-area" onClick={this.fileUploadClick.bind(this)}>
            <img src={attactment} alt="" className="ticket-attactment-icon" />
            <label className="ticket-attactment-label">Attach screenshot if required</label>
            <input type="file" id="fileUpload" hidden="true" onChange={this.getFileList.bind(this)} accept="image/*" />
          </div>
        </div>
        <div className="submit-btn-container">
          <input
            type="button"
            className="submit-btn"
            disabled={this.state.submitBtnDisable}
            onClick={this.onSubmitBtnClick.bind(this)}
            value="Add Message"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    headerMessage: {
      title: "New Message",
      description: "",
      backIcon: false,
      moreOptionhidden: true,
      searchOptionHidden: true
    },
    authorId: state.userId
  };
};
const mapDispatchToProps = dispatch => {
  return {
    ticketUpdated: () => {
      dispatch({
        type: SET_TICKET_LIST_RELOAD,
        payload: true
      });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewComment);



// WEBPACK FOOTER //
// ./src/components/Tickets/NewComment.js